import { de } from './de';
import { en } from './en';
import type { Language } from '../LanguageContext';

export { de, type TranslationKey } from './de';
export { en } from './en';

export function getTranslations(language: Language) {
  return language === 'de' ? de : en;
}
